Customer.Dashboard ||= {}

class Customer.Dashboard.TicketDetailsBoxView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/detail/box/ticket_details_box"]

  events:
    'click .box-title-conversation': 'onClickConversationTitle'
    'click .box-title-notes': 'onClickNotesTitle'
    'click .box-title-user': 'onClickUserTitle'
    'click .box-title-ai-summary': 'onClickAISummaryTitle'

  initialize: (@options = {}) ->
    @ticket = @options.ticket
    @priorities = @options.priorities
    @accountUsers = @options.account_users
    @selectedHeader = @options.selectedHeader || Keepcon.currentAccount.customer.defaultTicketDetailTab
    @ticketAttributesCollection ||= new Customer.ConversationAttributeCollection(@ticket.id)
    @ticketAttributesCollection.fetch(reset: true)
    interaction = @interactionOfUserToShow()
    @countCandidates(interaction)
    @doGetProfile()
    userView = new Customer.Dashboard.TicketDetailsUserView(
      interaction: @interactionOfUserToShow(),
      mergeCandidates: @candidateCount,
      userProfileResponse: @userProfileResponse
    )
    @listenTo(userView, 'recalculate:merge:candidates', @recalculateCandidateCount)
    @listenTo(userView, 'profile:cleared_candidates', @onClearedMergeCandidates)

    aiSummaryView = new Customer.Dashboard.TicketDetailsAISummaryView(ticket: @ticket)

    @contentViews = {
      conversation: new Customer.Dashboard.TicketDetailsConversationView(
        ticket: @ticket
        interaction: interaction
        priorities: @priorities
        ticketAttributesCollection: @ticketAttributesCollection
      )
      notes: new Customer.Dashboard.TicketDetailsNotesView(ticket: @ticket, account_users: @accountUsers)
      user: userView
      ai_summary: aiSummaryView
    }
    Backbone.on('validateCrmData', @_validateCrmDataListener)
    @listenTo(@ticket.get('integrations'), 'ticket:export:success', @onClickConversationTitle)
    @resetErrors()

  resetErrors: =>
    @errors =
      ticket_attribute_errors: {}
      user_profile_attribute_errors: {}

  render: (header, onFinish = ->) ->
    if @selectedHeader == header
      return onFinish()
    @selectedHeader = header || 'conversation'
    @$el.html(@template(ticket: @ticket, selectedHeader: @selectedHeader))
    @_showCandidatesNotification() if @candidateCount > 0
    @contentViews[@selectedHeader].delegateEvents()
    @$el.find('.box-content').html(@contentViews[@selectedHeader].render(onFinish).el)
    @toggleErrorIndicators(@errors.ticket_attribute_errors, 'conversation')
    @toggleErrorIndicators(@errors.user_profile_attribute_errors, 'user')
    @delegateEvents()
    @

  onClearedMergeCandidates: =>
    @$el.find('#merge-candidates-notification').addClass('d-none')
    @candidateCount = 0

  onClickConversationTitle: ->
    @render('conversation')

  onClickNotesTitle: ->
    @render('notes')

  onClickUserTitle: ->
    @render('user')

  onClickAISummaryTitle: ->
    @render('ai_summary')

  validateCrmData: (mandatoryFields, onFinish) ->
    if @contentViews['user'].isBeingModified() || @contentViews['conversation'].isBeingModified()
      onFinish(success: false, message: I18n.t('customer.dashboard.conversations.details.finish_changing_attributes'))
      return
    if @selectedHeader == 'user'
      @_validateCrmData(mandatoryFields, onFinish)
    else
      @render('user', => @_validateCrmData(mandatoryFields, onFinish))

  _validateCrmData: (mandatoryFields, onFinish) ->
    message = undefined
    success = true
    if mandatoryFields?.profile && mandatoryFields.profile.length > 0
      {success, message} = @contentViews['user'].validateFieldsAreFilled(mandatoryFields.profile)
    if success && mandatoryFields?.ticket && mandatoryFields.ticket.length > 0
      {success, message} = @contentViews['conversation'].validateFieldsAreFilled(mandatoryFields.ticket)
      unless success
        @selectedHeader = 'conversation'
        @render()
    onFinish({
      success
      profile_id: @contentViews['user'].userProfilePreviewView.profileId
      message
    })

  interactionOfUserToShow: ->
    loadedInteractions = _.reject(@ticket.allInteractions(), (i) -> i.isNotFound?())
    if @ticket.hasActiveParticipants()
      type: @ticket.type()
      id: @ticket.activeParticipants()
      starting_interaction: false
    else
      notResponses = _.filter(loadedInteractions, (i) -> !i.isResponseFromClient()) # 'client' means brand i.e. an integrated facebook page
      interaction = notResponses[0] || loadedInteractions[0]
      @_interactionToJson(interaction)

  showUserOf: (interaction) ->
    return if interaction.isNotFound?()
    @setInteraction(interaction)
    @onClickUserTitle()

  setInteraction: (interaction) ->
    @countCandidates(@_interactionToJson(interaction))
    userView = new Customer.Dashboard.TicketDetailsUserView(
      interaction: @_interactionToJson(interaction),
      mergeCandidates: @candidateCount,
      userProfileResponse: @userProfileResponse
    )
    @listenTo(userView, 'profile:cleared_candidates', @onClearedMergeCandidates)
    @contentViews.user = userView

  countCandidates: (interaction) ->
    return unless interaction?.id
    mergeCandidateCount = new Profile.UserProfile.MergeCandidateCount(
      source: interaction.type,
      social_network_id: interaction.id
    )
    mergeCandidateCount.fetch(
      error: -> showError(I18n.t('customer.dashboard.conversations.details.box.user.merge_count_error')),
      success: (count) => @mergeCandidateCountFetchedSuccesfully(count)
    )

  recalculateCandidateCount: ->
    @countCandidates(@interactionOfUserToShow())

  mergeCandidateCountFetchedSuccesfully: (count) =>
    @candidateCount = count.candidatesCount()
    if @candidateCount > 0
      @_showCandidatesNotification()
    else
      @_hideCandidatesNotification()
    @contentViews.user.updateCandidateCount(@candidateCount) if @contentViews.user?

  _showCandidatesNotification: =>
    @$el.find('#merge-candidates-notification').removeClass('d-none')

  _hideCandidatesNotification: =>
    @$el.find('#merge-candidates-notification').addClass('d-none')

  _interactionToJson: (interaction) ->
    return unless interaction
    {
      type: interaction.type(),
      id: interaction.get('social_network_id'),
      starting_interaction: interaction.isStartingInteraction()
    }

  updateFollowValues: ->
    return unless @selectedHeader == 'user'
    @contentViews[@selectedHeader].clearCache()
    @render()

  _validateCrmDataListener: ({mandatoryFields, ticketId, onFinish}) =>
    return if ticketId != @ticket.id
    @validateCrmData(mandatoryFields, onFinish)

  hidePrioritySpinner: ->
    @contentViews.conversation.hidePrioritySpinner()

  doGetProfile: =>
    interaction = @interactionOfUserToShow()
    return unless interaction?.id
    source = if interaction.type.toUpperCase().includes('LIVEFYRE') then 'livefyre' else interaction.type
    if I18n.t('google_play.user.anonymous') == @id && source == 'google_play'
      @showError()
    else
      _socialId = encodeURIComponent(interaction.id)
      $.ajax
        type: 'GET'
        url: "/profiles/api/#{source}/#{_socialId}"
        success: @onProfileLoad
        error: @showError

  onProfileLoad: (response) =>
    @userProfileResponse = response
    @contentViews.user.setuserProfileResponse(response)

  onAttributesValidationError: (response, skipAttributesErrorDetail = false) =>
    if @_isAttributeValidationPayload(response)
      @errors = response
      @setSelectedHeader()
      @render()
      @_createValidationErrorMessage(skipAttributesErrorDetail)
    else
      @resetErrors()
      @render()
      response?.message || I18n.t('customer.dashboard.errors.could_not_reply_over_this_message')

  _isAttributeValidationPayload: (response) ->
    response? and (response.ticket_attribute_errors? or response.user_profile_attribute_errors?)

  toggleErrorIndicators: (errors, componentName) =>
    return unless errors?
    return if Object.keys(errors).length == 0
    @_toggleValidationErrorIconVisibility(componentName, true)
    @contentViews[componentName].onAttributesValidationError(errors)

  _createValidationErrorMessage: (skipAttributesErrorDetail) ->
    errorMessageBuilder = new Customer.Ticket.AttributesValidationMessageBuilder
      ticketAttributesCollection: @ticketAttributesCollection
      userProfileAttributesCollection: @userProfileResponse.editable_attributes
      skipAttributesErrorDetail: skipAttributesErrorDetail
    errorMessageBuilder.createValidationErrorMessage(@errors)

  setSelectedHeader: ->
    hasTicketAttributeErrors = !_.isEmpty(@errors.ticket_attribute_errors)
    hasUserProfileAttributeErrors = !_.isEmpty(@errors.user_profile_attribute_errors)

    if hasTicketAttributeErrors && !hasUserProfileAttributeErrors
      @selectedHeader = 'conversation'

    if !hasTicketAttributeErrors && hasUserProfileAttributeErrors
      @selectedHeader = 'user'

  onTicketClose: =>
    @resetErrors()
    @_callOnTicketClose('conversation')
    @_callOnTicketClose('user')

  _callOnTicketClose: (componentName) =>
    @_toggleValidationErrorIconVisibility(componentName, false)
    @contentViews[componentName].onTicketClose()

  _toggleValidationErrorIconVisibility: (componentName, isVisible) ->
    @$el.find(".box-title-#{componentName} .validation-error-icon").toggleClass('d-none', !isVisible)
